import React, { useState } from "react";
import { Form, Button, Card, Row, Col, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import Layouts from "../../components/Layouts";
import {
  crearCamposFormulario,
  crearFormulario,
  obtenerSiguienteOrden,
} from "../../services/formularios";
import FormBuilder from "./components/FormBuilder";
import PreviewForm from "./components/PreviewForm";
import { useSelector } from "react-redux";

function Formularios() {
  const [form] = Form.useForm();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const userRole = useSelector((state) => state.userdata.role?.name);
  const userBodegaId = useSelector((state) => state.userdata.bodega?.id);
  const generateUniqueKey = (label) => {
    const randomNum = Math.floor(Math.random() * 10000);
    return `${label.toLowerCase().replace(/\s+/g, "")}${randomNum}`;
  };

  const onFinish = async (values) => {
    try {
     
      if (!values.campos || values.campos.length === 0) {
        message.error("Debe agregar al menos un campo al formulario");
        return;
      }
      
    
      const camposValidos = values.campos.every(campo => 
        campo.label && campo.tipo
      );
      
      if (!camposValidos) {
        message.error("Todos los campos deben tener una etiqueta y tipo definidos");
        return;
      }
      
      setLoading(true);
      
      // Determinar la bodega a usar
      let bodegaId;
      if (userRole === "adminapp" || userRole === "Administrator") {
        // Para administradores, usar la bodega seleccionada
        bodegaId = values.bodega;
      } else {
        // Para otros roles, usar la bodega del usuario
        bodegaId = userBodegaId;
      }

      // Crear el formulario
      const formularioResponse = await crearFormulario({
        nombre: values.nombre,
        descripcion: values.descripcion,
        bodega: bodegaId,
      });

      // Preparar los campos con orden automático
      const camposPromises = values.campos.map(async (field, index) => {
        const campoData = {
          formulario: formularioResponse.id,
          clave: generateUniqueKey(field.label),
          label: field.label,
          tipo: field.tipo,
          requerido: field.requerido,
          visible_app: field.visible_app,
          orden: index + 1,
          galeria: field.galeria,
          camara:field.camara
        };

        // Solo procesar opciones para campos de tipo select o multiple
        if (
          ["select", "multiple_unico", "multiple_multiple"].includes(
            field.tipo
          ) &&
          field.opciones
        ) {
          const opcionesArray = field.opciones.split(",").map(opt => opt.trim());
          campoData.opciones = opcionesArray.reduce((acc, opt) => {
            acc[opt] = opt;
            return acc;
          }, {});
        }
        if (["imagen"].includes(field.tipo)) {
          campoData.camara = field.camara || false;
          campoData.galeria = field.galeria || false;
        }
        return campoData;
      });

      const campos = await Promise.all(camposPromises);


      // Crear los campos del formulario
      await crearCamposFormulario(formularioResponse.id, campos);

      message.success("Formulario creado exitosamente");
      form.resetFields();
    } catch (error) {
      message.error(error.message || "Error al crear el formulario");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layouts>
      <div style={{ padding: "24px" }}>
        <Row gutter={24}>
          <Col span={previewVisible ? 14 : 24}>
            <Card
              title="Crear Nuevo Formulario"
              style={{
                maxWidth: previewVisible ? "100%" : 800,
                margin: "0 auto",
              }}
              extra={
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  onClick={() => setPreviewVisible(!previewVisible)}
                >
                  {previewVisible
                    ? "Ocultar Vista Previa"
                    : "Mostrar Vista Previa"}
                </Button>
              }
            >
              <FormBuilder form={form} loading={loading} onFinish={onFinish} />
            </Card>
          </Col>
          {previewVisible && (
            <Col span={10}>
              <PreviewForm form={form} />
            </Col>
          )}
        </Row>
      </div>
    </Layouts>
  );
}

export default Formularios;
